import { render } from "./PostWriter.vue?vue&type=template&id=7668b89c&ts=true"
import script from "./PostWriter.vue?vue&type=script&lang=ts"
export * from "./PostWriter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__